/**
 * Employee Web — `/me/profile/security` tab route (Plan 05.2-05).
 *
 * Password change CTA (live → /auth/forgot), 2FA status with enable (TOTP
 * setup dialog) + disable, and live active-sessions list backed by
 * GET /me/sessions + revoke endpoints.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { SecurityTab } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/profile/security")({
  staticData: { breadcrumb: { labelKey: "me-profile:tabs.security" } },
  component: SecurityTabRoute,
});

function SecurityTabRoute(): JSX.Element {
  return <SecurityTab />;
}
